export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 bg-accent-100 rounded-2xl flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-accent-600"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto">
              如果你发现皮皮漫画上的内容存在问题，或者有原创漫画希望投稿合作，
              欢迎通过以下方式联系我们。我们会在24小时内回复你的消息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                投稿合作
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-foreground-200 hover:border-accent-400 text-foreground-700 hover:text-accent-500 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bug-line"></i>
                内容反馈
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}